import { render, staticRenderFns } from "./QrDocument.vue?vue&type=template&id=826691a2&"
import script from "./QrDocument.js?vue&type=script&lang=js&"
export * from "./QrDocument.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports